import { lazy, Suspense } from 'react';
import Loader from '../custom/loader/main';
import { auth } from '../hooks/auth';

const Main = lazy(() => import('../components/merchants/billingConfiguration'));

const ViewBillingConfiguration = () => {
	return (
		<Suspense fallback={<Loader />}>
			<Main />
		</Suspense>
	);
};

export default auth(ViewBillingConfiguration);
